import React from 'react';
import cx from 'classnames';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
//
// export default function Fa({icon, style, className, ...props}) {
//   let hasKind = false;
//   let modifiers = Object.keys(props).map(mod => {
//     if (KINDS.has(mod))  {
//       hasKind = true;
//       return mod;
//     } else {
//       return 'fa-' + mod;
//     }
//   });
//   if (!hasKind) {
//     modifiers.unshift('fas');
//   }
//   if (icon) {
//     modifiers.push('fa-' + icon);
//   }
//   return <i className={cx(modifiers, className)} style={style} />
// }
//
// let KINDS = new Set(['fa', 'fas', 'fab', 'far', 'fal']);
//
// Fa.defaultProps = {
//   kind: 'fas'
// };

export const Fa = FontAwesomeIcon;
